import { PrivateConfig, PublicConfig } from "@interfaces";

// Injected by webpack.DefinePlugin
declare global {
	const WEBPACK_VERSION_NODE: string;
	const WEBPACK_VERSION_NPM: string;
	const WEBPACK_SB_CDN_BASE_URL: string;
	const WEBPACK_GRAPHQL_URI: string;
}

export const IS_SERVER = typeof window === "undefined";
export const IS_BROWSER = !IS_SERVER;

const ensureFloat = (value: string, defValue: number): number => {
	const float = parseFloat(value);
	return Number.isNaN(float) ? defValue : float;
};

const ensureInt = (value: string, defValue: number): number => {
	const int = parseInt(value, 10);
	return Number.isNaN(int) ? defValue : int;
};

export const publicConfig: PublicConfig = {
	NODE_ENV: process.env.NODE_ENV!,
	PORT: ensureInt(process.env.PORT!, 3000),
	CI: process.env.CI!,
	DEBUG_MODE: /^(yes|true|1)$/i.test(process.env.DEBUG_MODE ?? ""),
	ENV: process.env.ENV!,
	BUILD_NUMBER: process.env.BUILD_NUMBER!,
	RELEASE: process.env.RELEASE!,

	BASE_SITE_DOMAIN: process.env.BASE_SITE_DOMAIN!,
	STATIC_SITE_DOMAIN: process.env.STATIC_SITE_DOMAIN!,
	SB_CDN_HOST: process.env.SB_CDN_HOST!,
	AWS_S3_PUBLIC_HOST: process.env.AWS_S3_PUBLIC_HOST!,
	CANONICAL_DOMAIN: process.env.CANONICAL_DOMAIN!,

	SENTRY_DSN: process.env.SENTRY_DSN!,
	SENTRY_TRACING_RATE: ensureFloat(process.env.SENTRY_TRACING_RATE!, 0),
	SENTRY_SAMPLING_RATE: ensureFloat(process.env.SENTRY_SAMPLING_RATE!, 1),

	GRAPHQL_URI: WEBPACK_GRAPHQL_URI!,
	GRAPHQL_HEALTH_URL: process.env.GRAPHQL_HEALTH_URL!,

	CTF_ENV: process.env.CTF_ENV!,
	CTF_SPACE: process.env.CTF_SPACE!,
	CTF_TOKEN: process.env.CTF_TOKEN!,
	CTF_URL: process.env.CTF_URL!,
	CTF_API_URL: process.env.CTF_API_URL!,

	ZENDESK_URL: process.env.ZENDESK_URL!,
	ZENDESK_EMAIL: process.env.ZENDESK_EMAIL!,

	RECURLY_PUBLIC_KEY: process.env.RECURLY_PUBLIC_KEY!,
	VWO_ID: process.env.VWO_ID!,

	GTM_ENV_NAME: process.env.GTM_ENV_NAME!,
	GOOGLE_RECAPTCHA_SITE_KEY: process.env.GOOGLE_RECAPTCHA_SITE_KEY!,
	CASTLE_PUBLIC_KEY: process.env.CASTLE_PUBLIC_KEY!,

	SB_CDN_BASE_URL: WEBPACK_SB_CDN_BASE_URL!,
	VERSION_NODE: WEBPACK_VERSION_NODE!,
	VERSION_NPM: WEBPACK_VERSION_NPM!,

	HUBSPOT_PORTAL_ID: process.env.HUBSPOT_PORTAL_ID!,
	HUBSPOT_EBOOK_DOWNLOAD_FORM_ID: process.env.HUBSPOT_EBOOK_DOWNLOAD_FORM_ID!,

	// Additional
	COOKIE_NAME: "token",
};

export const contentfulProps = {
	environment: publicConfig.CTF_ENV as string,
	space: publicConfig.CTF_SPACE as string,
	accessToken: publicConfig.CTF_TOKEN as string,
	proxy: null,
};

export const privateConfig: PrivateConfig = {
	...publicConfig,
	CTF_CMA_TOKEN: process.env.CTF_CMA_TOKEN!,
	ZENDESK_TOKEN: process.env.ZENDESK_TOKEN!,
	REVALIDATE_SECRET: process.env.REVALIDATE_SECRET!,
};
